// extracted by mini-css-extract-plugin
export default {"page":"PageBar_page__Sakzu","label":"PageBar_label__r86L2"};